type Movement = { id: string; label: string; movementDate: string; isRevisionBaseline: boolean };
export function inventoryMovementPeriods<T extends Movement>(movements: T[]) {
  const revisions = movements.map((movement, index) => ({ movement, index }))
    .filter(item => item.movement.isRevisionBaseline);
  const periods = revisions.map((item, index) => ({
    id: item.movement.id,
    label: `${item.movement.label} (${new Date(item.movement.movementDate).toLocaleDateString('uk-UA')}) → ${revisions[index + 1] ? new Date(revisions[index + 1].movement.movementDate).toLocaleDateString('uk-UA') : 'зараз'}`,
    start: item.index,
    end: revisions[index + 1]?.index ?? movements.length,
  }));
  if (revisions.length && revisions[0].index > 0)
    periods.unshift({ id: 'before-first', label: 'До першої закритої ревізії', start: 0, end: revisions[0].index });
  return periods;
}
export function selectInventoryMovements<T extends Movement>(movements: T[], selected: string, includeEarlier: boolean) {
  const periods = inventoryMovementPeriods(movements);
  if (selected === 'all' || !periods.length) return movements;
  const period = selected === 'current' ? periods[periods.length - 1] : periods.find(item => item.id === selected) ?? periods[periods.length - 1];
  return movements.slice(includeEarlier ? 0 : period.start, period.end);
}
